/** Single HSBC vendor payments endpoint; route is sent as `rawPath` in the JSON body. */
export const HSBC_VENDOR_PAYMENTS_URL =
  "https://api.more.in/v1/hsbc_vendor_payments";

/** HSBC employee payments endpoint for employee upload and approval screens. */
export const HSBC_EMPLOYEE_PAYMENTS_URL =
  "https://api.more.in/v1/hsbc_employee_payments/";

/**
 * @param {string} rawPath - e.g. "/process_logs"
 * @param {Record<string, unknown>} payload - merged after rawPath
 */
export function hsbcBody(rawPath, payload = {}) {
  const path = rawPath.startsWith("/") ? rawPath : `/${rawPath}`;
  return { rawPath: path, ...payload };
}
